import * as yup from "yup";

export interface FormData {
  name: string;
  phoneNumber: string;
}

yup.setLocale({
  mixed: {
    required: "Dette felt er obligatorisk",
  },
});

export const validationSchema = () => {
  return yup.object().shape({
    name: yup.string(),
    phoneNumber: yup.string().required(),
  });
};

export const to = (_body: any) => {
  return "thomas.lovstrom@gjensidige.dk,peter-ploug.rasmussen@gjensidige.dk,Nicki.Ipsen@gjensidige.dk";
};

export default validationSchema;
